import { MagistralDrugRawMaterial, MedicineRawMaterialSimple, QuantityUnit } from '@dreryk/drerykweb-medicine-api';

import { MedicineRawMaterialTableBean } from '../../../shared/formFields/magistralDrug/medicineRawMaterials/MedicineRawMaterialTable.types';
import { UnitSelectCellQuantityUnit } from '../../../shared/formFields/magistralDrug/medicineRawMaterials/UnitSelectCell';

const isMedicineRawMaterialFromPharmindex = (
   medicine: MedicineRawMaterialTableBean
): medicine is Omit<MedicineRawMaterialTableBean, 'name'> & { name: MedicineRawMaterialSimple } =>
   typeof medicine.name !== 'string';

export const getMaterialUnit = (
   quantity: number | null,
   unit: UnitSelectCellQuantityUnit
): QuantityUnit | undefined => {
   if (!quantity || unit === 'NONE') {
      return undefined;
   }
   return unit;
};

export const mapMedicineRawMaterialsTableBeanToMagistralDrugRawMaterials = (
   medicineRawMaterials: MedicineRawMaterialTableBean[]
): MagistralDrugRawMaterial[] =>
   medicineRawMaterials.map((material) => {
      const shouldPassPharmindexMedicineDetails = isMedicineRawMaterialFromPharmindex(material);

      return {
         name: shouldPassPharmindexMedicineDetails
            ? `${material.name.name} (${material.name.nameForPrescription})`
            : (material.name as string),
         rpw: material.rpw,
         highDoseAlert: material.excessive,
         quantityAbbreviation: material.quantityAbbreviation!,
         quantity: material.quantity!,
         quantityUnit: getMaterialUnit(material.quantity, material.unit),
         eanCode: shouldPassPharmindexMedicineDetails ? material.name.eanCode : undefined,
         csiozCode: shouldPassPharmindexMedicineDetails ? material.name.csiozCode : undefined,
      };
   });
